import api from './axios'

// 음성 파일 전송(대화)
export const uploadConversationAudio = async(formData) => {
  const res = await api.post("language/conversations/transcribe", formData, {
    headers: { "Content-Type": "multipart/form-data" }
  });
  return res.data
}

// 대화 전체 조회
export const getConversationList = async() => {
  const res = await api.get("language/conversations")
  return res.data
}

// 대화 개별 조회
export const getConversation = async(id) => {
  const res = await api.get(`language/conversations/${id}`)
  return res.data
}

// 대화 기반 단어 등록
export const createConversationWord = async(id, data) => {
  const res = await api.post(`language/conversations/${id}/map-words`, data)
  return res.data
}

// 대화 제목 수정
export const updateTitle = async(id, data) => {
  const res = await api.patch(`language/conversations/${id}/title`, data);
  return res.data
}

// 대화 삭제
export const deleteConversation = async(id) => {
  const res = await api.delete(`language/conversations/${id}`)
  return res.data
}